import FormInput from 'components/Project/Form/FormInput';
import React, { useEffect } from 'react';
import { FiPlus } from 'react-icons/fi';
import { IntegrationInterface } from './Integration';
import AddParameter from './AddParameter';
import BorderGradient from 'components/shared/BorderGradient/BorderGradient';

interface IntegrationFormProps {
    formState: any;
    editedIntegrationId: string | null;
    mode: string;
    setMode: React.Dispatch<React.SetStateAction<string>>;
    integrations: IntegrationInterface[]
    setFormState: (formState: any) => void;
    setIntegrations: React.Dispatch<React.SetStateAction<IntegrationInterface[]>>;
    handleClose: () => void;
    setEditedIntegrationId: React.Dispatch<React.SetStateAction<string | null>>;
}

const IntegrationForm: React.FC<IntegrationFormProps> = ({ setEditedIntegrationId, mode, formState, integrations, editedIntegrationId, setFormState, handleClose, setIntegrations, setMode }) => {

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormState((prev: { [key: string]: any }) => ({ ...prev, [name]: value }));
    };




    // const editedInitialData = () => {
    //     const integrationToEdit = integrations.find((i: IntegrationInterface) => i.id === editedIntegrationId);
    //     console.log("integrationToEdit ======>", integrationToEdit);
    //     console.log("editedIntegrationId ======>", editedIntegrationId);
    //     if (!integrationToEdit) return;
    //     setFormState({
    //         id: integrationToEdit.id,
    //         integrationName: integrationToEdit?.service || '',
    //         integrationDescription: integrationToEdit?.description || '',
    //         integrationStatus: integrationToEdit?.status || false,
    //         integrationAddedOn: integrationToEdit?.addedOn || '',
    //     });
    //   };

    const handleSaveIntegration = () => {
        const newIntegration: IntegrationInterface = {
            id: Math.random().toString(36).substring(2, 6),
            service: formState.integrationName,
            description: formState.integrationDescription,
            status: formState.integrationStatus === 'true' || formState.integrationStatus === true,
            addedOn: formState.integrationAddedOn || new Date().toLocaleDateString(),
        };

        if (mode === 'edit' && editedIntegrationId) {
            setIntegrations(prev =>
                prev.map(integration =>
                    integration.id === editedIntegrationId ? newIntegration : integration
                )
            );
        } else {
            setIntegrations(prev => [...prev, newIntegration]);
        }

        // handleCloseModal();
        setFormState({ // Reset form
            integrationName: '',
            integrationDescription: '',
            integrationStatus: false,
            integrationAddedOn: '',
        });
        handleClose();
        // setEditedIntegrationId(null);
        setMode('add');
        setEditedIntegrationId("");

    };




    useEffect(() => {
        if (mode === "edit" && editedIntegrationId) {
            const integrationToEdit = integrations.find((i: IntegrationInterface) => i.id === editedIntegrationId);
            if (integrationToEdit) {
                setFormState({
                    integrationName: integrationToEdit.service,
                    integrationDescription: integrationToEdit.description,
                    integrationStatus: integrationToEdit.status,
                    integrationAddedOn: integrationToEdit.addedOn,
                    // integrationType: integrationToEdit.integrationType || '',
                    // integrationApikey: integrationToEdit.integrationApikey || '',
                    // integrationApiSecret: integrationToEdit.integrationApiSecret || '',
                    // integrationEndpointurl: integrationToEdit.integrationEndpointurl || '',
                    // integrationCallbackurl: integrationToEdit.integrationCallbackurl || '',
                    // integrationEmailFrom: integrationToEdit.integrationEmailFrom || '',
                    // integrationSender: integrationToEdit.integrationSender || '',
                    // username: integrationToEdit.username || '',
                    // password: integrationToEdit.password || '',
                });
            }
        } else {
            setFormState({ // Reset form
                integrationName: '',
                integrationDescription: '',
                integrationStatus: false,
                integrationAddedOn: '',
            });
        }

    }, [editedIntegrationId, mode]);



    return (
        <div>

            <BorderGradient className='mt-8'>
                <div className='bg-[#232323] rounded-lg p-2 '>
                    <h3 className='text-white font-medium'>Integration details</h3>
                </div>
            </BorderGradient>

            <div className="grid grid-cols-2 gap-x-4 gap-y-0 mt-5">
                <FormInput
                    id="integrationName"
                    name="integrationName"
                    value={formState.integrationName}
                    placeholder="Integration Name"
                    onChange={handleInputChange}
                />
                <FormInput
                    id="integrationDescription"
                    name="integrationDescription"
                    value={formState.integrationDescription}
                    placeholder="Description"
                    onChange={handleInputChange}
                />
                <div className=''>
                    <label className="block text-sm text-gray-400 mb-1">Integration Type</label>
                    <select
                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                        id="integrationType"
                        name="integrationType"
                        value={formState.integrationType}
                        onChange={handleInputChange}
                    >
                        <option value="ticketing-system">Ticketing system</option>
                        <option value="payment-gateway">Payment Gateway</option>
                        <option value="payment-gateway">Email Service</option>
                        <option value="sms-service">SMS Service</option>
                        <option value="smtp">SMTP</option>
                    </select>
                </div>
                <div className=''>
                    <label className="block text-sm text-gray-400 mb-1">Status</label>
                    <select
                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                        id="integrationStatus"
                        name="integrationStatus"
                        value={formState.integrationStatus}
                        onChange={handleInputChange}
                    >
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                </div>
            </div>

            <BorderGradient className='mt-8'>
                <div className='bg-[#232323] rounded-lg p-2 '>
                    <h3 className='text-white font-medium'>Connection settings</h3>
                </div>
            </BorderGradient>

            <div className="grid grid-cols-2 gap-x-4 gap-y-0 mt-5">
                <FormInput
                    id="integrationApikey/token"
                    name="integrationApikey/token"
                    value={formState.integrationApikey}
                    placeholder="API Key/Token"
                    onChange={handleInputChange}
                />
                <FormInput
                    id="integrationApiSecret"
                    name="integrationApiSecret"
                    value={formState.integrationApiSecret}
                    placeholder="API Secret"
                    onChange={handleInputChange}
                />
                <FormInput
                    id="integrationEndpointurl"
                    name="integrationEndpointurl"
                    value={formState.integrationEndpointurl}
                    placeholder="Endpoint URL"
                    onChange={handleInputChange}
                />
                <FormInput
                    id="integrationCallbackurl"
                    name="integrationCallbackurl"
                    value={formState.integrationCallbackurl}
                    placeholder="Callback URL"
                    onChange={handleInputChange}
                />
                <FormInput
                    id="integrationEmailFrom"
                    name="integrationEmailFrom"
                    value={formState.integrationEmailFrom}
                    placeholder="Email From"
                    onChange={handleInputChange}
                />
                <FormInput
                    id="integrationSender"
                    name="integrationSender"
                    value={formState.integrationSender}
                    placeholder="Sender"
                    onChange={handleInputChange}
                />


            </div>

            <BorderGradient className='mt-8'>
                <div className='bg-[#232323] rounded-lg p-2 '>
                    <h3 className='text-white font-medium'>Authentication settings</h3>
                </div>
            </BorderGradient>

            <div className="mt-5">
                <div className="flex items-center gap-2">
                    <input
                        type="checkbox"
                        name="configureOAuth"
                        id="configureOAuth"
                        
                        className="w-5 h-5 rounded-md border border-gray-300   checked:bg-blue-500 checked:ring-blue-500 "
                    />

                    <label htmlFor='configureOAuth'>Configure OAuth</label>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-5">
                    <FormInput
                        id="username"
                        name="username"
                        value={formState.username}
                        placeholder="Username"
                        onChange={handleInputChange}
                    />
                    <FormInput
                        id="password"
                        name="password"
                        value={formState.password}
                        placeholder="Password"
                        onChange={handleInputChange}
                    />

                </div>
            </div>

            <BorderGradient className='mt-8'>
                <div className='bg-[#232323] rounded-lg p-2 '>
                    <h3 className='text-white font-medium'>Additional settings</h3>
                </div>
            </BorderGradient>

            <div className="mt-5">
                <div className="flex items-center gap-2">
                    <input
                        type="checkbox"
                        name="enableInteg"
                        id="enableInteg"
                       
                        className="w-5 h-5 rounded-md border border-gray-300   checked:bg-blue-500 checked:ring-blue-500 "
                    />

                    <label htmlFor='enableInteg'>Enable Integration</label>
                </div>
            </div>

            <div className="mt-5">
                <AddParameter />
            </div>


            <div className="flex justify-end mt-8 gap-5">
                <button
                    className="flex items-cente justify-center gap-2 px-4 py-2 w-[200px] bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                    onClick={handleClose}>
                    Test
                </button>
                <button
                    className="flex items-center justify-center text-center gap-2 px-4 py-2 w-[200px] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                    onClick={handleSaveIntegration}
                >
                    Save integration
                </button>
            </div>

        </div>
    );
};

export default IntegrationForm;
